// Tags list page (CHG-1266 / ITER-3391).
//
// FINAL ε ENTITY canary. FORWARD-PROMISED backend per CHG-1237 — page
// renders against the entity-hint contract, API client uses safeFetch
// wrappers that return empty data on 404, page never crashes.
// Cross-screen spec declares runtime_status: pending_t2_t4.
//
// Spec: specs/tier-05-experience/tags-v2.cross-screen.yaml.

import { ListPage } from "../components/composition";
import { tagListConfig } from "../generated/screens/tag-list";

export function Tags() {
  return <ListPage config={tagListConfig} />;
}
